import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ProvisionZoomAsync as ProvisionZoomAsyncMutation,
    ProvisionZoomAsync_provisionZoomAsync as ProvisionZoomAsyncPayload,
} from 'nutshell-graphql-types';

import PROVISION_ZOOM_ASYNC from '../mutations/provision-zoom-async.graphql';

export const useProvisionZoomAsync = (): {
    provisionZoomAsync: () => Promise<ProvisionZoomAsyncPayload | undefined>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [provisionZoomAsync, {loading, error}] =
        useMutation<ProvisionZoomAsyncMutation>(PROVISION_ZOOM_ASYNC);

    return {
        provisionZoomAsync: () =>
            provisionZoomAsync().then((result) => result?.data?.provisionZoomAsync),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
